import {productList,productDetails,withdrawPackage,providerList,bossList,countryList,addProduct,upProduct,delProduct,batchDelProduct} from 'api/product';
import {syncProduct} from "../../api/syncProduct";
import Cookies from 'js-cookie';

const product = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        productList({commit},params) {
            return new Promise((resolve, reject) => {
                productList(params.productId, params.productName,params.agent,params.providerId, params.zoneName, params.psize, params.currentPage,params.bossId, params.providerList, params.ccList, params.onSale, params.isOta,params.productCode,params.target,params.selectAccount,params.accountType).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        productDetails({commit}, productId) {
            return new Promise((resolve, reject) => {
                productDetails(productId).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        withdrawPackage({commit},params) {
            return new Promise((resolve, reject) => {
                withdrawPackage(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        providerList({commit},params){
            return new Promise((resolve, reject) => {
                providerList(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        bossList({commit},params){
            return new Promise((resolve, reject) => {
                bossList(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        countryList({commit},params){
            return new Promise((resolve, reject) => {
                countryList(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        addProduct({commit},params) {
            return new Promise((resolve, reject) => {
                addProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        upProduct({commit},params) {
            return new Promise((resolve, reject) => {
                upProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        delProduct({commit},params) {
            return new Promise((resolve, reject) => {
                delProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        batchDelProduct({commit},params) {
            return new Promise((resolve, reject) => {
                batchDelProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        syncProduct({commit},params) {
            return new Promise((resolve, reject) => {
                syncProduct(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default product;



// WEBPACK FOOTER //
// ./src/store/modules/product.js